/* eslint-disable react/prop-types */

import React  from 'react';

import { Alert, Badge } from 'react-bootstrap';

import { observer } from 'mobx-react';

import { ReactComponent as GoodToGoSVG } from '../../assets/verified_24dp.svg';
import { ReactComponent as InProgressSVG } from '../../assets/chef_hat_24dp.svg';

// eslint-disable-next-line complexity
const ScanSummary = observer(({orderStore, scanSettings}) => {
    if (!orderStore || orderStore.loading || !scanSettings) {
        return null;
    }

    const match = {};

    if (scanSettings.school !== 'Any') match.school = scanSettings.school;
    if (scanSettings.orderType !== 'Any') match.orderType = scanSettings.orderType;

    const counts = orderStore.countOrderStates(match);

    if (counts === null) return null;

    const goodToGo
        = (counts.placed || 0) === 0
        && (counts.printed || 0) === 0
        && (counts.prepared || 0) === 0
        && (counts.sent || 0) === 0
        && counts.packed > 0;

    return (
        <Alert variant='light' className='mt-2 centered-box'>
            <Alert.Heading>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    Summary
                    {
                        goodToGo
                        ? <span style={{ color: 'var(--col-ll-kiwidark)' }}><GoodToGoSVG /> Good to Go</span>
                        : <span style={{ color: 'var(--col-ll-darkyellow)' }}><InProgressSVG /> In Progress...</span>
                    }
                </div>
            </Alert.Heading>
            <hr />
            <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                <div className='summary-count'>Cancelled: <Badge bg='danger'>{orderStore.cancelledOrders.length || 0}</Badge></div>
                <div className='summary-count'>Placed: <Badge bg='warning'>{counts.placed || 0}</Badge></div>
                <div className='summary-count'>Printed: <Badge>{counts.printed || 0}</Badge></div>
                <div className='summary-count'>Sent: <Badge bg='info'>{counts.sent || 0}</Badge></div>
                <div className='summary-count'>Prepared: <Badge bg='info'>{counts.prepared || 0}</Badge></div>
                <div className='summary-count'>Packed: <Badge bg='success'>{counts.packed || 0}</Badge></div>
            </div>
        </Alert>
    );
});

export { ScanSummary };
